<template lang="pug">
  a.toxis(href="https://gorillatoxis.ru" target="_blank")
    img(src="~@/assets/img/header/toxis-promo.png")
</template>

<script>

export default {
  name: 'HeaderToxis'
}
</script>
